<template>
  <div class="v-tabs p-relative z-2">
    <div class="v-tabs__tabs-container">
      <div class="container">
        <div
          v-for="(tab, i) in tabs"
          :key="i"
          :class="[{ '--active': tabIndex === i }, 'v-tabs__tab']"
          @click="() => swiper.slideTo(i)"
        >
          {{ tabLabel(tab) }}
        </div>
      </div>

      <div ref="tab-container" class="v-tabs__content-container swiper">
        <div class="swiper-wrapper">
          <v-page
            v-for="(tab, i) in tabs"
            :key="tabLabel(tab)"
            class="swiper-slide v-tabs__tab-content"
          >
            <slot
              :name="
                tabLabel(tab)
                  .toLowerCase()
                  .replace(' ', '')
              "
              :active="tabIndex === i"
            />
          </v-page>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper"
import { isString } from "@/lib/utils"

export default {
  props: {
    tabs: { type: Array, required: true }, // Array<String> || Array<{ text: String, path: String }>
    initialTabIndex: { type: Number, default: 0 }
  },

  data() {
    return {
      tabIndex: this.initialTabIndex,
      activeTabHeight: 100,
      swiper: null
    }
  },

  methods: {
    tabLabel(tab) {
      return isString(tab) ? tab : tab.text
    }
  },

  mounted() {
    this.swiper = new Swiper(this.$refs["tab-container"], {
      initialSlide: this.tabIndex
    })

    this.swiper.on("slideChange", swiper => {
      this.tabIndex = swiper.activeIndex
    })

    if (this.tabs[0] && !isString(this.tabs[0])) {
      setTimeout(() => {
        this.swiper.slideTo(
          this.tabs.findIndex(tab => tab.path === this.$route.path) || 0
        )
      }, 150)
    }
  },

  watch: {
    tabIndex() {
      const activeTab = this.tabs[this.tabIndex]
      if (!isString(activeTab) && this.$route.path !== activeTab.path) {
        this.$router.replace(activeTab.path)
      }
    }
  }
}
</script>

<style lang="scss">
@import "~swiper/swiper.scss";

@import "@/assets/styles/variables";

.v-tabs {
  top: -2px;
  background: $color-ui--white;
}

.v-tabs__tabs-container {
  width: 100%;
  position: relative;
  z-index: 10;

  & > .container {
    display: flex;
    border-bottom: 1px solid $color-ui--grey-20;
  }
}

.v-tabs__tab {
  font-weight: 500;
  position: relative;
  bottom: -1px;
  flex-grow: 1;
  flex-basis: 0;
  width: auto;
  padding: $size--3;
  text-align: center;
  font-size: $font-size--small;
  border-bottom: 2px solid transparent;
  text-transform: capitalize;
  transition: border-color 0.2s ease;

  &:hover {
    cursor: pointer;
  }

  &.--active {
    border-color: var(--brand-color-hex);
  }
}

.v-tabs__tab-content {
  width: 100%;

  &.is-selected {
    opacity: 1;
  }
}
</style>
